export default function CTASection() {
  return (
    <section className="bg-background-50">
      <div className="mx-auto max-w-[1440px]">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-1/2 bg-secondary-100 relative overflow-hidden">
            <div className="w-full h-[400px] md:h-[550px] relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20vibrant%20news%20app%20interface%20with%20trending%20headlines%2C%20held%20by%20a%20hand%20against%20warm%20ambient%20background%2C%20soft%20natural%20lighting%20from%20window%2C%20lifestyle%20product%20photography%2C%20editorial%20tech%20lifestyle%20aesthetic%2C%20warm%20neutral%20tones%20with%20subtle%20golden%20accents%2C%20clean%20minimalist%20composition&width=600&height=900&seq=cta-mockup&orientation=portrait"
                alt="黑料入口APP下载"
                title="黑料入口下载 - 黑料入口app"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute top-8 left-8">
              <span className="text-xs font-medium text-foreground-600 uppercase tracking-wider">随时随地</span>
            </div>
            <div className="absolute bottom-8 left-8">
              <h2 className="font-heading text-4xl md:text-6xl font-bold text-foreground-950 leading-tight">
                不错过<br />任何一个<br />大瓜
              </h2>
            </div>
          </div>

          <div className="w-full md:w-1/2 flex flex-col items-center justify-center px-6 py-14 md:py-0 md:px-16 text-center">
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
              下载黑料入口APP
            </h2>
            <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight mt-2">
              吃瓜快人一步
            </h3>
            <p className="text-sm md:text-base text-foreground-500 mt-6 leading-relaxed max-w-sm">
              下载黑料入口官方APP，第一时间接收推送通知，再也不用担心错过任何重磅爆料。支持iOS和Android双平台。
            </p>
            <p className="text-sm text-foreground-400 mt-3 leading-relaxed max-w-sm">
              51吃瓜黑料入口一二三 | 黑料入口官网 | 黑料入口下载
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 mt-8">
              <button className="whitespace-nowrap px-8 py-3.5 rounded-full bg-foreground-950 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-apple-line text-lg"></i>
                App Store 下载
              </button>
              <button className="whitespace-nowrap px-8 py-3.5 rounded-full border border-foreground-300/40 text-foreground-700 text-sm font-medium hover:bg-foreground-100 transition-colors flex items-center gap-2 cursor-pointer">
                <i className="ri-android-line text-lg"></i>
                Android 下载
              </button>
            </div>
            <div className="flex items-center gap-4 mt-6">
              <span className="text-xs text-foreground-400">黑料入口app</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-foreground-400">黑料网站入口</span>
              <span className="text-xs text-foreground-400">·</span>
              <span className="text-xs text-foreground-400">黑料网址</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}